module.exports = "<div ng-repeat=\"frame in $ctrl.frames\" ng-class=\" $ctrl.frameClass(frame.index)\" class=\"f-col span\"><sc-frame-view id=\"id_remote_frame_{{frame.index}}\" ng-if=\"frame.url\" src=\"frame.url\" class=\"sc-view-container\" maximize=\"true\" handle-on-load=\"$ctrl.onFrameLoad(frame)\" on-frame-load=\"$ctrl.onFrameLoad(frame)\"></sc-frame-view></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/quad-frames/quad-view.component.html
// module id = 478
// module chunks = 0